const emailReportsNamespace = '/email_reports';

const emailReportListViewRelative = '/';

const emailReportListViewRoute = `${emailReportsNamespace}`;

export const emailReportsNamespaces = {
    emailReportsNamespace,
};

export const emailReportsRelativeRoutes = {
    emailReportListViewRelative,
};

export const emailReportsAbsoluteRoutes = {
    emailReportListViewRoute,
};
